module.exports = __webpack_public_path__ + "geometric.jpg?0792027c2fec93a14660dec070c658b4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/geometric.jpg
// module id = 476
// module chunks = 10